import React from 'react';
import { Select } from 'antd';

const { Option } = Select;

const Dropdown = ({ classname, label, options, ...rest }) => {
  return (
    <div>
      {label && <p className="text-md font-bold">{label}</p>}
      <Select id="dropdown-select" size="large" className="w-full" {...rest}>
        {options.map((option) => {
          return (
            <Option key={option.value} value={option.value}>
              <label htmlFor="dropdown-select">{option.label}</label>
            </Option>
          );
        })}
      </Select>
    </div>
  );
};

export default Dropdown;
